<template>
  <DialogQRFail ref="QRFail" fail-title="読み込みがうまくいきませんでした" />
</template>

<script>
import { apiWrapper } from "@/services/api";

export default {
  name: "TemplatePRX",
  watch: {
    $route() {
      location.reload();
    },
  },
  methods: {
    async PRX() {
      try {
        // keyでリクエストを行う
        var resp = await apiWrapper(
          "GET",
          `proxy_codes/${this.$route.query.key}`
        );

        // 上のAPIで該当文字列がレスポンスで帰ってくるので
        // それをクエリパラメータにしたSetQRを開く→watchでリロードされる(onMounted発火のため)
        this.$router.push("/SetQR?" + resp.data.original_code);
      } catch (err) {
        // 失敗したらダイアログ
        this.$refs.QRFail.openDialog();
      }
    },
  },
};
</script>
